<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="app-main-inner-row">
        <div class="triggers">
          <el-button no="new" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
          <el-button no="edit" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
          <el-button no="delete" type="danger" @click="doDelete">{{ $t('common.btn.delete') }}</el-button>
        </div>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          no="grid"
          config-module="101376"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
    </div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="maintainDialog.isShow"
      :close-on-click-modal="false"
      :title="maintainDialog.title"
      width="350px"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px">
        <el-form :model="maintainDialog.form" :label-width="isZh ? '100px' : '145px'" label-position="left">
          <!--字段展示 1-业务模块 2-付款申请模块-->
          <el-form-item :label="$t('CargoMsg.Cargo_FieldDisplay')" required>
            <cargo-advance-select
              no="fieldDisplay"
              tag-value="code"
              filterable
              :clearable="false"
              :default-value="maintainDialog.form.fieldDisplay"
              :static-options="SystemConstants.FIELD_DISPLAY_MODULES"
              @parentCallBack="fieldDisplayChangeHandle"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Field')" required>
            <cargo-advance-select
              no="CustomFields"
              :select-type="selectTypeNames.local_cache_CustomFields$CUSTOM_FIELDS"
              :clearable="false"
              :default-value="maintainDialog.form.fieldCode"
              :static-options="maintainDialog.form.fieldDisplay === SystemConstants.FIELD_DISPLAY_BUSINESS_MODULE.code ?
                SystemConstants.CUSTOM_FIELDS_BUSINESS : SystemConstants.CUSTOM_FIELDS_PAYMENT_REQUEST"
              @parentCallBack="fieldChangeHandle"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.ChineseDisplayName')" required>
            <el-input v-model="maintainDialog.form.chineseName" no="chineseName" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.EnglishDisplayName')" required>
            <el-input v-model="maintainDialog.form.englishName" no="englishName" />
          </el-form-item>
          <!--控件选择 1-文本框 2-下拉框-->
          <el-form-item :label="$t('CargoMsg.Cargo_ControlSelection')" required>
            <cargo-advance-select
              no="widgetType"
              tag-value="code"
              filterable
              :clearable="false"
              :disabled="maintainDialog.form.fieldDisplay === SystemConstants.FIELD_DISPLAY_BUSINESS_MODULE.code"
              :default-value="maintainDialog.form.widgetType"
              :static-options="SystemConstants.WIDGET_TYPES"
              @parentCallBack="p => {maintainDialog.form.widgetType = p.value;maintainDialog.form.enumStr = '' }"
            />
          </el-form-item>
          <el-form-item
            v-if="maintainDialog.form.fieldDisplay != SystemConstants.FIELD_DISPLAY_BUSINESS_MODULE.code &&
              maintainDialog.form.widgetType === SystemConstants.WIDGET_TYPE_DROPDOWN.code"
            :label="$t('CargoMsg.Cargo_EnumValue')"
            required
          >
            <el-input
              v-model="maintainDialog.form.enumStr"
              type="textarea"
              :disabled="maintainDialog.form.fieldDisplay === SystemConstants.FIELD_DISPLAY_BUSINESS_MODULE.code"
              :rows="3"
              no="enumStr"
            />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button no="save" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="cancelSaveOrEdit">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { getLoading } from '@/utils/utilBaseElement'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import {
  delCustomField,
  getCustomFieldList,
  saveCustomField, updateCustomField
} from '@/api/sysManage/baseConfig/customFieldDisplayConfiguration'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { refreshCustomField } from '@/utils/customFields'
import { FIELD_DISPLAY_BUSINESS_MODULE } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'CustomFieldDisplayConfiguration',
  components: {
    cargoAdvanceSelect
  },
  data() {
    return {
      SystemConstants,
      selectTypeNames: TYPE_NAMES,
      loading: false,
      columnDefs: [
        {
          headerName: '',
          width: 55,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: false
        },
        {
          headerName: this.$t('CargoMsg.Field'),
          field: 'fieldCode',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveCustomField(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.ChineseDisplayName'),
          width: 300,
          field: 'chineseName'
        },
        {
          headerName: this.$t('CargoMsg.EnglishDisplayName'),
          field: 'englishName',
          width: 300
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FieldDisplay'),
          field: 'fieldDisplay',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.FIELD_DISPLAY_MODULES)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ControlSelection'),
          field: 'widgetType',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.WIDGET_TYPES)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EnumValue'),
          field: 'enumStr',
          width: 300
        }
      ],
      originRowData: [],
      rowData: [],
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false
      },
      maintainDialog: {
        isShow: false,
        title: this.$t('CargoMsg.CustomFieldDisplayConfiguration'),
        form: {
          uuid: '',
          fieldCode: 0,
          chineseName: '',
          englishName: '',
          fieldDisplay: SystemConstants.FIELD_DISPLAY_BUSINESS_MODULE.code, // 字段展示 1-业务模块 2-付款申请模块
          widgetType: SystemConstants.WIDGET_TYPE_TEXTBOX.code, // 控件选择 1-文本框 2-下拉框
          enumStr: '' // 枚举值 以逗号分隔
        }
      }
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    gridApi() {
      return this.gridParams.api
    }
  },
  mounted() {
    this.fetchCustomFieldList()
  },
  methods: {
    // 字段变更
    fieldChangeHandle(p) {
      this.maintainDialog.form.fieldCode = p.value
      if (this.maintainDialog.form.fieldDisplay === SystemConstants.FIELD_DISPLAY_BUSINESS_MODULE.code) {
        // 业务模块，【自定义字段1~4】《-》【自定义岗位1~2】，此时设置 控件选择 类型
        if ([SystemConstants.CUSTOM_FIELD_1.code, SystemConstants.CUSTOM_FIELD_2.code, SystemConstants.CUSTOM_FIELD_3.code, SystemConstants.CUSTOM_FIELD_4.code].indexOf(this.maintainDialog.form.fieldCode) > -1) {
          this.maintainDialog.form.widgetType = SystemConstants.WIDGET_TYPE_TEXTBOX.code
        } else {
          this.maintainDialog.form.widgetType = SystemConstants.WIDGET_TYPE_DROPDOWN.code
        }
      }
      this.maintainDialog.form.chineseName = ''
      this.maintainDialog.form.englishName = ''
      this.maintainDialog.form.enumStr = ''
    },
    // 字段展示变更
    fieldDisplayChangeHandle(p) {
      this.maintainDialog.form.fieldDisplay = p.value
      this.maintainDialog.form.fieldCode = 0
      this.maintainDialog.form.widgetType = SystemConstants.WIDGET_TYPE_TEXTBOX.code
      this.maintainDialog.form.chineseName = ''
      this.maintainDialog.form.englishName = ''
      this.maintainDialog.form.enumStr = ''
    },
    fetchCustomFieldList() {
      this.loading = getLoading()
      getCustomFieldList().then(res => {
        this.rowData = res.data.list
        if (this.gridApi) {
          this.gridApi.clearFocusedCell()
        }
      }).finally(() => this.loading.close())
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.maintainDialog.form = {
          uuid: '',
          fieldCode: 0,
          chineseName: '',
          englishName: '',
          fieldDisplay: SystemConstants.FIELD_DISPLAY_BUSINESS_MODULE.code, // 字段展示 1-业务模块 2-付款申请模块
          widgetType: SystemConstants.WIDGET_TYPE_TEXTBOX.code, // 控件选择 1-文本框 2-下拉框
          enumStr: '' // 枚举值 以逗号分隔
        }
        this.maintainDialog.title = this.$t('CargoMsg.Cargo_NewTo')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.maintainDialog.form = { ...rows[0] }
        this.maintainDialog.title = this.$t('CargoMsg.Cargo_EditTo')
      }
      this.maintainDialog.isShow = true
    },
    async doDelete() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      await self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        type: 'warning'
      })
      self.loading = getLoading()
      await delCustomField(rows[0].uuid).then(() => {
        self.$message.success(self.$t('common.tips.deleteSuccess'))
        self.fetchCustomFieldList()
      }).finally(() => self.loading.close())
      refreshCustomField()
    },
    cancelSaveOrEdit() {
      this.maintainDialog.isShow = false
    },
    async save() {
      const self = this
      if (!self.maintainDialog.form.fieldCode) {
        self.$message.warning(self.$t('CargoMsg.FieldNotEmpty'))
        return
      }
      if (!self.maintainDialog.form.chineseName) {
        self.$message.warning(self.$t('CargoMsg.ChineseDisplayNameNotEmpty'))
        return
      }
      if (!self.maintainDialog.form.englishName) {
        self.$message.warning(self.$t('CargoMsg.EnglishDisplayNameNotEmpty'))
        return
      }
      // 枚举值不能为空
      if (self.maintainDialog.form.fieldDisplay !== SystemConstants.FIELD_DISPLAY_BUSINESS_MODULE.code &&
        self.maintainDialog.form.widgetType === SystemConstants.WIDGET_TYPE_DROPDOWN.code && !self.maintainDialog.form.enumStr) {
        self.$message.warning(self.$t('CargoMsg.Cargo_EnumValue') + self.$t('queryJob.CannotBeEmpty'))
        return
      }
      this.loading = getLoading()
      if (!self.maintainDialog.form.uuid) {
        await saveCustomField(self.maintainDialog.form).then(() => {
          this.maintainDialog.isShow = false
          self.$message.success(self.$t('common.tips.saveSuccess'))
          self.fetchCustomFieldList()
        }).finally(() => {
          self.loading.close()
        })
      } else {
        await updateCustomField(self.maintainDialog.form).then(() => {
          this.maintainDialog.isShow = false
          self.$message.success(self.$t('common.tips.editSuccess'))
          self.fetchCustomFieldList()
        }).finally(() => {
          self.loading.close()
        })
      }
      refreshCustomField()
    }

  }

}
</script>
